import React from 'react';
import cn from 'classname';
import './index.less';

import get from 'lodash/get';

const prefix = 'new-table__head__item__th';

function renderUnit({ className, hint, child }) {
	return (
		<span className={className} title={hint}>{child}</span>
	);
}

export function renderDefaultTH({ index, header }, props) {
	const hint = props.intl(header.description);

	const unitProps = header.icon ? {
		className: cn(`${prefix}__icon`, header.icon)
	} : {
		child: header.title
	};

	return (
		<th
			className={cn(prefix, header.className, props.className)}
			rowSpan={header.rowSpan}
			colSpan={header.colSpan}
			onClick={props.onClick}
			key={index}
		>
			{renderUnit({ ...unitProps, hint })}
		</th>
	);
}

export function renderDefaultTD({ index, column }, props) {
	const value = get(props.row, index);

	const child = (value == null)
		? '-'
		: column.format ? column.format(value) : value;

	const hint = column.hint && props.intl(column.hint(value));

	const render = column.render || renderUnit;

	return (
		<td className={column.className} key={index}>
			{render({ value, child, hint }, props)}
		</td>
	);
}

// with sorting:

function renderSortingTH(item, { intl, sorting, sort }) {
	const isActive = item.index === sorting.index;
	const key = item.header.icon ? 'icon' : 'head';

	const className = cn({
		[`${prefix}__sort-${key}`]: true,
		[`${prefix}__sort-${key}-active`]: isActive,
		[`${prefix}__sort-${sorting.direction}`]: isActive && !!sorting.direction,
		[`${item.header.className}-active`]: !!item.header.className && isActive
	});

	return renderDefaultTH(item, { intl, className, onClick: () => sort(item) });
}

export function createRenderSortingTH({ sortedBy, sort }) {
	function renderTH(item, props) {
		if (!item.header.sorting) {
			return renderDefaultTH(item, props);
		}

		const sorting = sortedBy[item.header.sorting.key];

		return renderSortingTH(item, { ...props, sorting, sort });
	}

	return renderTH;
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-table/renderers/index.js